import React, { useEffect, useState } from 'react';

import cx from 'classnames';
import { Link } from 'react-scroll';

import Icon from 'components/shared/Icon';
import ScrollArrow2 from 'components/shared/Icon/icons/ScrollArrow2';
import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import { useContainerScrollPosition } from 'components/shared/LandingPage/functions';
import { useLandingNavigation } from 'hooks/useLandingNavigation';

import styles from './index.module.css';

function ScrollArrowLink(props) {
  const { links = [], isPortal = false, isItinerariesItem = false, isPortalItinerary = false, landingTheme } = props;
  const { isScrolledToBottom, isScrolledToTop } = useContainerScrollPosition();
  const lastLinkIndex = links.length - 1;
  const [activeLinkIndex, setActiveLinkIndex] = useState(isScrolledToBottom ? lastLinkIndex : 0);
  const { getBaseOffset, handleLinkClick } = useLandingNavigation({
    isItinerariesItem,
    isPortal,
    isPortalItinerary,
    elemId: 'pageHeadline',
    type: 'arrowLink',
    landingTheme,
  });
  const isLastLink = activeLinkIndex === lastLinkIndex;

  const scrollArrowClasses = cx(
    styles.scrollArrow,
    (isLastLink || isScrolledToBottom) && styles.scrollArrowRotate,
    (isPortal || isPortalItinerary) && styles.scrollArrowPortal,
    'custom-scroll-arrow',
  );

  const handleSetActive = (to) => {
    const index = links.findIndex((l) => l === to);

    if (index > -1) {
      setActiveLinkIndex(index);
    }
  };

  useEffect(() => {
    if (isScrolledToBottom) {
      setActiveLinkIndex(lastLinkIndex);
    }

    if (isScrolledToTop) {
      setActiveLinkIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScrolledToBottom, isScrolledToTop]);

  return (
    <>
      {links.map((link, i) => {
        if (!link) return null;
        return (
          <Link
            key={i}
            to={link}
            style={{ display: (activeLinkIndex + 1) % links.length === i ? 'block' : 'none' }}
            className={scrollArrowClasses}
            containerId={LANDING_PAGES_CONTAINER_ID}
            smooth={true}
            duration={200}
            spy={true}
            offset={getBaseOffset()}
            ignoreCancelEvents={false}
            onSetActive={handleSetActive}
            isDynamic
            onClick={() => handleLinkClick(link, LANDING_PAGES_CONTAINER_ID)}
          >
            <Icon component={ScrollArrow2} className={cx(styles.scrollArrowIcon, 'custom-scroll-arrow-icon')} />
          </Link>
        );
      })}
    </>
  );
}

export default ScrollArrowLink;
